import {
    Divider, List
} from '@mui/material'

import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'

import { useLocation } from 'react-router-dom'
import { createId } from '../../../services/utils'

import Link from './Link'
import Submenu from './Submenu'

import Styles from './style'

import Schema from '../../../features/menu/menu.json'
import Config from '../../../features/config.json'

export const Menu = () => {
    const navigationStore = useSelector(state => state.navigation)

    const url = useLocation()
    const pathname = url.pathname

    const [schemaMapper, setSchemaMapper] = useState([])

    useEffect(() => {
        let mapper = []

        const useNavigationMock = Config.interface?.navigation?.useMock ?? false
        const usedSchema = (useNavigationMock)
            ? (navigationStore.data?.items ?? []) : Schema

        for (let i = 0; i < usedSchema.length; i++) {
            if (pathname?.includes(usedSchema[i].root)) {
                mapper = usedSchema[i].items
                break
            } else mapper = []
        }

        setSchemaMapper(mapper)
    }, [pathname, navigationStore])

    return (
        <List sx={Styles.root} component="nav">
            {schemaMapper.length > 0 && schemaMapper.map(item => {
                const key = createId()
                if (item.hide === true) return

                if (item.items && item.items.length > 0) {
                    let isOpen = false
                    let isSubOpen = false

                    for (let i = 0; i < item.items.length; i++) {
                        if (item.items[i].path === pathname)
                            isOpen = true
                        else if (item.path && item.path === pathname) {
                            isOpen = true
                            isSubOpen = true
                        }

                        if (isOpen || isSubOpen) break
                    }

                    return (
                        <Submenu
                            open={isOpen}
                            subOpen={isSubOpen}
                            items={item.items}
                            icon={item.icon}
                            label={item.label}
                            disabled={item.disabled}
                            path={item.path}
                            key={key}
                        />
                    )
                }
                else if (item.label === '-') return (<Divider key={key} />)

                return (
                    <Link
                        items={item.items}
                        label={item.label}
                        path={item.path}
                        target={item.target}
                        icon={item.icon}
                        disabled={item.disabled}
                        key={key}
                    />
                )
            })}
        </List>
    )
}

export default Menu